<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees class="row my-5"></app-nav-gestion-donnees>

	<div *ngIf="user" class="row my-3 theme-main-color">
		<div class="row">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i
						>{{ user.firstName + ' ' + user.lastName }}</span
					>
				</div>

				<div class="">
					<a
						*ngIf="isDeletable"
						(click)="openModal(deleteUser)"
						class="btn theme-red-button px-4"
					>
						Supprimer la fiche
					</a>
				</div>
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="rounded bg-light">
			<div *ngIf="isFormReadOnly">
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="inputLastName" class="form-label fw-bold"
							>Nom</label
						>
						<span class="form-control-plaintext">{{
							user?.lastName
						}}</span>
					</div>
					<div *ngIf="user.firstName" class="col-12 col-lg-6">
						<label for="firstName" class="form-label fw-bold">Prénom</label>
						<span class="form-control-plaintext" id="firstName">{{
							user.firstName
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="inputUsername" class="form-label fw-bold"
							>Nom d'utilisateur</label
						>
						<span class="form-control-plaintext">{{
							user?.username
						}}</span>
					</div>
					<div class="col-12 col-lg-6">
						<label for="telephone" class="form-label fw-bold">Téléphone</label>
						<span class="form-control-plaintext" id="telephone">{{
							user.telephone
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<!-- <div class="col-12 col-lg">
						<label for="inputAddresse" class="form-label fw-bold"
							>Adresse</label
						>
						<span class="form-control-plaintext">{{
							user?.address?.label
						}}</span>
					</div> -->
					<div *ngIf="user.email" class="col-12 col-lg-6">
						<label for="email" class="form-label fw-bold">Email</label>
						<span class="form-control-plaintext" id="email">{{
							user.email
						}}</span>
					</div>
					<div class="col-12 col-lg-6">
						<div class="form-check form-switch ms-3">
							<input
								[disabled]="isFormReadOnly"
								[attr.disabled]="isFormReadOnly"
								class="form-check-input theme-main-border-color"
								type="checkbox"
								id="actif"
								[checked]="user.active"
								[ngClass]="{
									'theme-main-color-check': user.active
								}"
							/>
							<label class="form-check-label text-dark" for="actif"
								>Actif</label
							>
						</div>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="inputProfile" class="form-label fw-bold"
							>Rôle</label
						>
						<span class="form-control-plaintext">{{
							user?.profile?.name
						}}</span>
					</div>
				</div>


			</div>
			<app-user-form
				*ngIf="!isFormReadOnly"
				[user]="user"
				[isAddForm]="false"
				[form]="form"
				[isAddressSelected]="isAddressSelected"
				[isAddressDefault]="isAddressDefault"
				[isValidateButtonClicked]="isValidateButtonClicked"
				(sendForm)="onSubmit()"
			>
			</app-user-form>
		</div>
		<div class="row my-4">
			<div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm()"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="!form.valid || isValidateButtonClicked.value"
					class="btn theme-green-button"
					type="submit"
					form="form"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>

	<ng-template #deleteUser>
		<div class="modal-header text-center">
			<h4>Suppression {{ labelUserCapitalized }}</h4>
			<button
				type="button"
				class="btn-close pull-right"
				data-bs-dismiss="modal"
				aria-label="Close"
				(click)="confirmDeleteModalRef.hide()"
			></button>
		</div>
		<div class="modal-body">
			Êtes-vous sûr de vouloir effectuer la suppression ?
		</div>
		<div class="modal-footer">
			<a
				(click)="confirmDeleteModalRef.hide()"
				class="btn theme-main-color-button"
				>Retour</a
			>
			<a class="btn theme-red-button ms-3" (click)="delete(user)"
				>Supprimer</a
			>
		</div>
	</ng-template>
</div>
